import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "communitySelect",
    "productSelect",
    "creditScoreInput",
    "locationSelect",
    "basicsSubmitter",
    "basicsHint",
    "mapsLink"
  ]
  static values = {
    availableProducts: Object,
    communityNames: Object,
    communityPlaceIds: Object
  }

  connect() {
    this.filterProducts()
    this.updateMapsLink()
    this.hideBasicsButton()
    this.restoreFocus()
    this.locationTouched = this.hasLocationSelectTarget && this.locationSelectTarget.value !== ""
  }

  communityChanged() {
    this.filterProducts()
    this.updateMapsLink()
  }

  locationChanged() {
    this.locationTouched = true
    this.checkBasics()
  }

  hideBasicsButton() {
    if (this.hasBasicsSubmitterTarget) {
      this.basicsSubmitterTarget.classList.add("hidden")
    }
    if (this.hasBasicsHintTarget) {
      this.basicsHintTarget.classList.add("hidden")
    }
  }

  checkBasics() {
    clearTimeout(this.basicsTimeout)
    this.basicsTimeout = setTimeout(() => {
      this.evaluateAndSubmit()
    }, 400)
  }

  evaluateAndSubmit() {
    if (!this.locationTouched) return

    if (
      !this.hasCommunitySelectTarget ||
      !this.hasProductSelectTarget ||
      !this.hasCreditScoreInputTarget ||
      !this.hasLocationSelectTarget ||
      !this.hasBasicsSubmitterTarget
    ) return

    const communityId = this.communitySelectTarget.value
    const productId = this.productSelectTarget.value
    const creditScore = parseInt(this.creditScoreInputTarget.value, 10)
    const locationType = this.locationSelectTarget.value

    const allPresent = communityId && productId && !isNaN(creditScore) && creditScore >= 300 && creditScore <= 900 && locationType

    if (allPresent) {
      if (document.activeElement && this.element.contains(document.activeElement)) {
        this.constructor.lastFocusedId = document.activeElement.id
      }
      this.basicsSubmitterTarget.click()
    }
  }

  restoreFocus() {
    const lastId = this.constructor.lastFocusedId
    if (lastId) {
      const elementToFocus = this.element.querySelector(`#${lastId}`)
      if (elementToFocus) {
        elementToFocus.focus()
        if (elementToFocus.type === "number" || elementToFocus.type === "text") {
          const val = elementToFocus.value
          elementToFocus.value = ""
          elementToFocus.value = val
        }
      }
      this.constructor.lastFocusedId = null
    }
  }

  filterProducts() {
    if (!this.hasCommunitySelectTarget || !this.hasProductSelectTarget) return

    const communityId = this.communitySelectTarget.value
    const allowedProducts = this.availableProductsValue?.[communityId] || []
    const communityName = this.communityNamesValue?.[communityId]

    Array.from(this.productSelectTarget.options).forEach((option) => {
      if (option.value === "") return

      const originalName = option.dataset.productName || option.textContent
      const enabled = communityId === "" || allowedProducts.includes(parseInt(option.value, 10))

      option.disabled = !enabled
      option.textContent = enabled || !communityName ? originalName : `${originalName} (Unavailable in ${communityName})`
    })

    const selectedOption = this.productSelectTarget.selectedOptions[0]
    if (selectedOption && selectedOption.disabled) {
      this.productSelectTarget.value = ""
    }
  }

  updateMapsLink() {
    if (!this.hasMapsLinkTarget) return

    const communityId = this.communitySelectTarget.value
    const placeId = this.communityPlaceIdsValue?.[communityId]

    if (placeId) {
      const communityName = this.communityNamesValue?.[communityId]
      const destination = encodeURIComponent(`${communityName}, British Columbia, Canada`)
      this.mapsLinkTarget.href = `https://www.google.com/maps/dir/?api=1&destination=${destination}&destination_place_id=${placeId}&travelmode=driving`
      this.mapsLinkTarget.classList.remove("hidden")
    } else {
      this.mapsLinkTarget.href = "#"
      this.mapsLinkTarget.classList.add("hidden")
    }
  }
}
